import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_GRAPHQL

export const sendEmailMovierOrderPending = async orderId => {
  console.log(baseUrl)
  try {
    const result = await axios.post(
      baseUrl,
      {
        query: `query{
            getOrderMovieV2(orderId: ${orderId}){
              id
              paymentSituation
            }
          }`
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    return result.data.data
  } catch (e) {
    console.log(e)
    return []
  }
}

export const reversalPayment = async orderId => {
  try {
    const result = await axios.post(
      baseUrl,
      {
        query: `mutation {
          refundVouchersByOrder(id: ${orderId})
          }`
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    return result.data.data
  } catch (e) {
    console.log(e)
    return []
  }
}
